export const ACCOUNT_DIGITS_LENGTH = 20;
export const ACCOUNT_INVALID_MESSAGE = 'Неверный номер счёта';
/** Маска из макета: 00000 00000 00000 00000 */
const ACCOUNT_DISPLAY_PATTERN = '##### ##### ##### #####';

/** Коэффициенты ключа расчётного счёта (ЦБ РФ): БИК[-3:] + счёт. */
const ACCOUNT_CHECK_WEIGHTS = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1];

export function extractAccountDigits(value: string): string {
	return value.replace(/\D/g, '').slice(0, ACCOUNT_DIGITS_LENGTH);
}

export function formatAccountDisplay(digits: string): string {
	const normalized = extractAccountDigits(digits);

	if (!normalized) {
		return '';
	}

	let i = 0;
	const formatted = ACCOUNT_DISPLAY_PATTERN.replace(/\S/g, () => normalized[i++] || '');

	let lastDigitIndex = -1;

	for (let index = 0; index < formatted.length; index++) {
		if (/\d/.test(formatted[index]!)) {
			lastDigitIndex = index;
		}
	}

	return lastDigitIndex < 0 ? '' : formatted.slice(0, lastDigitIndex + 1);
}

export function isAccountChecksumValid(bikDigits: string, accountDigits: string): boolean {
	const bik = bikDigits.replace(/\D/g, '');
	const account = extractAccountDigits(accountDigits);

	if (bik.length < 3 || account.length !== ACCOUNT_DIGITS_LENGTH) {
		return false;
	}

	const value = `${bik.slice(-3)}${account}`;
	let sum = 0;

	for (let index = 0; index < ACCOUNT_CHECK_WEIGHTS.length; index++) {
		sum += Number(value[index]) * ACCOUNT_CHECK_WEIGHTS[index]!;
	}

	return sum % 10 === 0;
}

export function isAccountNumberValid(digits: string, bikDigits?: string): boolean {
	const account = extractAccountDigits(digits);

	if (account.length !== ACCOUNT_DIGITS_LENGTH) {
		return false;
	}

	if (bikDigits && bikDigits.replace(/\D/g, '').length >= 3) {
		return isAccountChecksumValid(bikDigits, account);
	}

	return true;
}

/** Ошибка под полем: все 20 цифр введены, но ключ счёта не сходится с БИК. */
export function getAccountNumberError(digits: string, bikDigits?: string): string | null {
	const account = extractAccountDigits(digits);

	if (account.length !== ACCOUNT_DIGITS_LENGTH) {
		return null;
	}

	if (!bikDigits || isAccountChecksumValid(bikDigits, account)) {
		return null;
	}

	return ACCOUNT_INVALID_MESSAGE;
}
